/**
 * Created by Administrator on 2017/11/1.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import { DragulaService } from 'ng2-dragula/ng2-dragula';
declare var alertify:any;
@Component({
  templateUrl:'./address.html'
})

export class Address implements OnInit{
  constructor(
    private router:Router,
    private http:HttpService,
    private dragulaService: DragulaService
  ){
    dragulaService.drop.subscribe((value) => {
      //console.log('drop: ${value[0]}');
      this.onDrop(value.slice(1));
    });
  }



  private data:any=[];
  private imagePath:string='';

  private onDrop(args) {
    let [e, el] = args;
    // do something
    this.getList();
  }

  private postData:any=[
  ];

  //获取排序列表
  private getList(){
    this.postData = [];
    for(let i=1;i<this.data.length+1;i++){
      this.postData.push({'id':this.data[i-1].id,'rank':i});
    }
  }

  private sort():void{
    for (let i=0;i<this.postData.length;i++){
      console.log('id:'+this.postData[i].id+",rank:"+this.postData[i].rank);
    }
    this.http.postData(API.aboutAddress+"/aboutSort",this.postData).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }


  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
      })
  }




  private getData(){
    this.http.getData(API.aboutAddress).then(res=>{
      this.data = res.data;
      for (let i=0;i<this.data.length;i++){
        this.data[i].iconEn = this.imagePath+this.data[i].iconEn;
        this.data[i].iconTc = this.imagePath+this.data[i].iconTc;
      }
    });
  }

  private editNews(id:number):void{
    this.router.navigate(['index/address',id])
  }

  private delete(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.aboutAddress+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }

  ngOnInit(): void {
    this.getPath();
    this.getData();
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/address/address.component.ts